///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, toastSuccessActionCreators, initKioskManagerActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN, API_TOKEN_DL_FILE } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getKiosksBusinessView = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters

	const apiCall = R.GET_INIT_KIOSKS_BUSINESS(payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(initKioskManagerActionCreators.getKiosksBusinessViewSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskManagerActionCreators.getKiosksBusinessViewFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const getKiosksCustomerView = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters
	const apiCall = R.GET_INIT_KIOSKS_CUSTOMER(payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)

		yield put(initKioskManagerActionCreators.getKiosksCustomerViewSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskManagerActionCreators.getKiosksCustomerViewFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putKioskBuild = function* ({ payload }) {
	const requestId = payload.requestId
	const query = payload.query
	let MsgParams = ''

	if (query === 'StartBuildRequest') {
		MsgParams = 'toast__initKiosk__startBuild'
	} else if (query === 'FinishBuildRequest') {
		MsgParams = 'toast__initKiosk__finishBuild'
	} else if (query === 'InstallSoftKioskRequest') {
		MsgParams = 'toast__admin__initKiosk__kioskSoftInstalled'
	} else if (query === 'CancelRequest') {
		MsgParams = 'toast__initKiosk__cancelRequest'
	} else if (query === 'ReactivateRequest') {
		MsgParams = 'toast__initKiosk__reactivateRequest'
	} else if (query === 'ValidateQuote') {
		MsgParams = 'toast__initKiosk__validateQutote'
	} else if (query === 'FinishConfigRequest') {
		MsgParams = 'toast__initKiosk__kioskCreation_factoryFloor__configFinished'
	} else if (query === 'FactoryFloor') {
		MsgParams = 'toast__initKiosk__kioskCreation_factoryFloor__validate'
	}

	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters
	const apiCall = R.PUT_KIOSK_BUILD(requestId, query)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bodyMsg)

		yield put(initKioskManagerActionCreators.putKioskBuildSuccess())
		//yield put(initKioskManagerActionCreators.setIsKioskUpdated());

		yield put(toastSuccessActionCreators.hydrateToast(MsgParams))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskManagerActionCreators.putKioskBuildFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const viewProductionSheet = function* ({ payload }) {
	const requestId = payload.requestId

	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters
	const apiCall = R.PUT_KIOSK_BUILD(requestId, 'ShowProductionSheetRequest')

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN_DL_FILE(user.jwt).put(apiCall, bodyMsg)

		// Chrome doesn't handle properly the content-disposition where we put filename in there.
		// So we can't use a File object in url var.
		// Instead, we create a fake link tag, and we got a direct download
		var url = URL.createObjectURL(new Blob([data.data], { type: 'application/pdf' }))
		var fileLink = document.createElement('a')
		fileLink.href = url
		fileLink.download = data.headers['content-disposition'].split('=')[1]
		fileLink.target = '_blank'
		fileLink.click()

		yield put(initKioskManagerActionCreators.viewProductionSheetSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(initKioskManagerActionCreators.viewProductionSheetFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_INIT_KIOSKS_BUSINESS, getKiosksBusinessView)
	yield takeLatest(ActionsTypes.GET_INIT_KIOSKS_CUSTOMER, getKiosksCustomerView)
	yield takeLatest(ActionsTypes.PUT_KIOSK_BUILD, putKioskBuild)
	yield takeLatest(ActionsTypes.VIEW_PRODUCTION_SHEET, viewProductionSheet)
}

export default sagas
